import React from 'react';
import {
    Chart as ChartJS,
    RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
    Tooltip,
    Legend,
  } from 'chart.js';
import { Radar } from 'react-chartjs-2';
import ChartDataLabels from "chartjs-plugin-datalabels";
import './Chart.css';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend,
    ChartDataLabels
);

export default function RadarChart(props) {
  return(
    <div height={props.hChart+"px"} width={props.wChart} style={{"height": props.hChart, "minHeight": "100px", "width": props.wChart}}>
        <Radar id={props.id} options={props.options} data={props.chartData.data} className="canvasChart"/>
    </div>
  );
}

//<Bar options={props.chartData.options} data={props.chartData.data} />